import { WorkSpaceUser } from '../models'
import { VENDOR } from '../helpers'
import { APPLICATION_SLUGS } from '../constants/applications'

/**
 * Returns true if the workspace user's company has access to the given application (by slug).
 * Used by route guards to block access when the company has not opted into an application.
 * Vendors (company_type === VENDOR) always have access to EZTurn regardless of application list.
 */
export function hasApplication(
    workspaceUser: WorkSpaceUser | undefined,
    slug: string,
): boolean {
    const workspace = workspaceUser?.active_workspace
    if (!workspace) {
        return false
    }
    if (
        workspace.company_type === VENDOR &&
        slug.toLowerCase() === APPLICATION_SLUGS.EZTURN
    ) {
        return true
    }
    if (!workspace.applications?.length) {
        return false
    }
    const slugs = new Set(
        workspace.applications.map((app) => app.slug.toLowerCase()),
    )
    return slugs.has(slug.toLowerCase())
}
